//  TODO env
export const API = process.env.REACT_APP_CMS_URL ?? "https://0102-01.sulu.wicode.io"
export const CDS = {
    API: process.env.REACT_APP_CDS_API_URL ?? "https://cds.wicode.io/contact/with-attachments",
    KEY: process.env.REACT_APP_CDS_API_KEY ?? ""
}
